import { render, staticRenderFns } from "./DetailsPanel.vue?vue&type=template&id=c4ffe112&scoped=true"
import script from "./DetailsPanel.vue?vue&type=script&lang=js"
export * from "./DetailsPanel.vue?vue&type=script&lang=js"
import style0 from "./DetailsPanel.vue?vue&type=style&index=0&id=c4ffe112&prod&scoped=true&lang=scss"
import style1 from "./DetailsPanel.vue?vue&type=style&index=1&id=c4ffe112&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ffe112",
  null
  
)

export default component.exports